<div>
  <p-panel>
    <p-header class="w-100">
      <i class="fa fa-bolt amarillo" aria-hidden="true"></i> {{ titleKey | translate }} <div class="float-right m-l-xs">
        <button class="btn btn-xs btn-default float-right" (click)="expanded=!expanded">
          <i class="pi" [ngClass]="{'pi-plus': !expanded, 'pi-minus': expanded}"></i>
        </button>
      </div>
      <div class="float-right">
        <span class="label label-warning-light float-right" *ngIf="isLoaded() && expanded">{{ 'AuditUser.latest.results'
          | translate }} {{pagInfo.size}} </span>
      </div>
    </p-header>
    <div *ngIf="!isLoaded()">
      <waitLoading [maxView]="false" *ngIf="!isLoaded()"></waitLoading>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div *ngIf="isLoaded() &&(!auditUserList || auditUserList.length === 0)"
          class="alert alert-info m-b-xs text-ellipsis col-12">
          <span>
            <i class="fas fa-1-5x fa-info-circle m-r-md" aria-hidden="true"></i> {{ 'AuditUser.noData' | translate
            }}</span>
        </div>
        <div *ngIf="isLoaded() && auditUserList && auditUserList.length>0" class="col-12">
          <div *ngFor='let element of auditUserList; let num=index' class="audit-list-element ">
            <div class="card border-0 p-0" *ngIf="element.dateOpen && (expanded || num==0)">
              <div class="card-body p-0">
                <!--dossierDetail [dossier]="element.project"
								 [infoTitulo]="false" class="d-inline"></dossierDetail-->
                <divisionDetail [project]="element.project" [infoLink]="true" [infoTitulo]="false" class="d-inline">
                </divisionDetail>
                <h5 class="card-title d-inline">{{element.description}}</h5>
                <!--p class="card-text">...</p-->
                <ul class="list-group list-group-flush">
                  <li class="list-group-item p-1" (mouseenter)="auditTooltip.toggle($event)"
                    (mouseleave)="auditTooltip.toggle($event)"><i class="fa fa-check"
                      title="{{ 'AuditUser.dispatched' | translate }}"></i> {{element.dateDesp | date:'medium'}}</li>
                </ul>
                <p-overlayPanel #auditTooltip appendTo="body" [showTransitionOptions]="'1000ms'"
                  [hideTransitionOptions]="'500ms'">
                  <div> <i class="fa fa-check" title="{{ 'AuditUser.dispatched' | translate }}"></i> {{element.dateDesp
                    | date:'medium'}}</div>
                  <div><i class="fa fa-envelope-open-text" title="{{ 'AuditUser.opening' | translate }}"></i>
                    {{element.dateOpen | date:'medium'}}</div>
                  <div><i class="fa fa-envelope" title="{{ 'AuditUser.arrival' | translate }} "></i>
                    {{element.dateArrival | date:'medium'}}</div>
                </p-overlayPanel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </p-panel>
</div>